import apiClient from "@/api/client";

export interface ProvisioningDefaults {
  nameservers: string;
  searchdomain: string;
  disclaimer_snippet: string;
}

export async function getProvisioningDefaults(): Promise<ProvisioningDefaults> {
  const { data } = await apiClient.get<ProvisioningDefaults>(
    "/provisioning/defaults",
  );
  return data;
}
